import type { EmblaCarouselType } from 'embla-carousel';

export const carousels = $state<Record<string, EmblaCarouselType>>({})